import { useState } from "react";

import { LoaderContextProvider } from "context/GlobalLoader";

import Loader from "components/Loader";

import ScrollToTop from "widgets/ScrollToTop";
import Toasts from "widgets/Toast";
import WidgetModal from "./widgets/Modal";
import RoutesComponent from "./widgets/Routes";

function App() {
  const [isLoading, setLoading] = useState(false);

  const handleLoad = (isLoad: boolean) => {
    setLoading(isLoad);
  };

  return (
    <LoaderContextProvider value={{ isLoading, handleLoad }}>
      <ScrollToTop />
      <Loader isLoading={isLoading} />
      <Toasts />
      <RoutesComponent />
      <WidgetModal />
    </LoaderContextProvider>
  );
}

export default App;
